import PropTypes from 'prop-types'
import React from 'react'
import css from './SignupCustomerQuote.module.css'
import { ASSET_BASE_URL } from 'config'

const quotes = {
  engineering: {
    content: 'We chose Segment over a tag manager because they were able to provide the whole range of analytics, marketing, advertising and product services.',
    name: 'Dario Vergara',
    avatar: 'dario-vergara.png',
    title: 'VP of Engineering',
    company: 'Bonobos'
  },
  research: {
    content: 'Segment saves us a crazy amount of money. We’ve cut engineering time from months to seconds and given our analytics and marketing teams the power to easily test and try new apps with replay.',
    name: 'Jon Hawkins',
    avatar: 'jon-hawkins.png',
    title: 'Director of Analytics and SEO',
    company: 'XO Group Inc.'
  },
  marketing: {
    content: 'Implementing a bunch of analytics tools is not sexy, and engineers don’t want to do it. Luckily, with Segment, they don’t have to.',
    name: 'Fareed Mosavat',
    avatar: 'fareed-mosavat.jpg',
    title: 'Senior Growth PM',
    company: 'Instacart'
  }
}

const SignupCustomerQuote = props => {
  const { role } = props
  const quote = quotes[role]

  if (!quote) {
    return null
  }

  return (
    <div className={css.main}>
      <img
        className={css.avatar}
        src={`${ASSET_BASE_URL}/images/${quote.avatar}`}
        alt={quote.name} />

      <div className={css.content}>{quote.content}</div>
      <div className={css.citation}>
        <span className={css.name}>{quote.name}, </span>
        <span className={css.title}>{quote.title} at {quote.company}</span>
      </div>
    </div>
  )
}

SignupCustomerQuote.propTypes = {
  role: PropTypes.string
}

export default SignupCustomerQuote



// WEBPACK FOOTER //
// ./components/SignupCustomerQuote.js